var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmShareFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.58C14.24 14.58 13.56 14.88 13.04 15.35L5.91 11.2C5.96 10.97 6 10.74 6 10.5C6 10.26 5.96 10.03 5.91 9.8L12.96 5.69C13.5 6.19 14.21 6.5 15 6.5C16.66 6.5 18 5.16 18 3.5C18 1.84 16.66 0.5 15 0.5C13.34 0.5 12 1.84 12 3.5C12 3.74 12.04 3.97 12.09 4.2L5.04 8.31C4.5 7.81 3.79 7.5 3 7.5C1.34 7.5 0 8.84 0 10.5C0 12.16 1.34 13.5 3 13.5C3.79 13.5 4.5 13.19 5.04 12.69L12.16 16.85C12.11 17.06 12.08 17.28 12.08 17.5C12.08 19.11 13.39 20.42 15 20.42C16.61 20.42 17.92 19.11 17.92 17.5C17.92 15.89 16.61 14.58 15 14.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmShareFull);
export default __webpack_public_path__ + "static/media/sm-share-full.d7c1f148.svg";
export { ForwardRef as ReactComponent };